import { FC, useContext } from 'react'
import { ChannelCanvas, channelCanvasHeight } from './ChannelCanvas'
import './Channel.scss'
import classNames from 'classnames'
import { CutterContext } from '../contexts/CutterContext'
import { useTranslation } from 'react-i18next'

interface Props {
  index: number
  channelsCount: number
}

export const Channel: FC<Props> = ({ index, channelsCount }) => {
  const { t } = useTranslation()
  const {
    audio: { numberOfChannels },
  } = useContext(CutterContext)

  return (
    <div
      className={classNames('Channel', {
        '-last': index === numberOfChannels - 1,
      })}
      style={{ height: channelCanvasHeight }}
    >
      <div className="name">
        {channelsCount === 1 ? t('Mono') : index === 0 ? t('Left') : index === 1 ? t('Right') : null}
      </div>

      <ChannelCanvas index={index} />
    </div>
  )
}
